import { mutate } from "swr"

import useCollection from "./useCollection"
import API from "./api"

import { useCreateModal } from "web/hooks/modals"

export default function useLayouts({ subjectType, topicId = "none" }) {
  const createModal = useCreateModal()

  const key = `/layouts/${subjectType}/${topicId || "none"}`
  const updatePath = "/layouts"

  const data = useCollection({ key, updatePath })

  function reorderFields(layoutId) {
    return async (from, to) => {
      await API.post(`/layouts/${layoutId}/reorder_fields`, { from, to })
      mutate(key)
    }
  }

  async function addLayout(copy = false, copy_from_id) {
    return await createModal({
      kind: "layout",
      collection: data,
      addParams: { copy_from_layout_id: copy ? copy_from_id : null },
    })
  }

  for (const el of data) {
    el.reorderFields = reorderFields(el.id)
  }

  data.addLayout = addLayout
  return data
}
